import { RoleGroup, ROLE_GROUPS } from './authorization/roles';

interface quicklinks {
  id: number;
  title: string;
  link: string;
  requiresIPD?: boolean;
  allowedRoles?: RoleGroup;
}

export const buildHeaderMenu = (isIPDEnabled: boolean): quicklinks[] => {
  const menus: quicklinks[] = [
    { id: 1, title: 'LABEL.DASHBOARD', link: '/dashboard', allowedRoles: ROLE_GROUPS.TenantAndPharmacy },
    { id: 2, title: 'LABEL.PATIENTS', link: '/patient', allowedRoles: ROLE_GROUPS.AllTenant },
    { id: 3, title: 'LABEL.APPOINTMENTS', link: '/appointment', allowedRoles: ROLE_GROUPS.AllTenant },
  ];

  menus.push({ id: 4, title: 'LABEL.QUEUE', link: '/opd/consultation', allowedRoles: ROLE_GROUPS.Consultation });

  if (isIPDEnabled) {
    menus.push({
      id: 5,
      title: 'ENTITY.IPD',
      link: '/ipd/management',
      allowedRoles: ROLE_GROUPS.AllTenant,
    });
  }

  menus.push({ id: 6, title: 'ENTITY.PHARMACY', link: '/pharmacy', allowedRoles: ROLE_GROUPS.Pharmacy });

  return menus;
};
